export default __webpack_public_path__ + "static/nailtools-b962138c035a8b73cccc8d3789463bc9.png";